<template>
  <div v-if="product">
    <PassChoice :normalProducts="[product]" ref="choice" :prorata="prorata">
      <template #title>
        <h2>Le Pass <strong class="serenite">Sérénité</strong></h2>
      </template>

      <template #description>
        <p class="supplement">
          Le Pass Sérénité est un supplément dont le coût s'ajoute à celui du Pass Idylive.
        </p>

        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/filtre.png" />Le filtre de contacts me permet d'être
          contacté(e) uniquement par les membres qui vous plaisent par critère de sexe, d'âge, de région...
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/visite.png" />Je peux voir date de dernière connexion
          (approximative) des autres membres.
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/message.png" />Je suis informé(e) de la réception de
          votre message par votre interlocuteur (accusé de réception des messages).
        </div>
        <div>
          <img class="iconesSerenite" src="/assets/icons/paiement/parametre.png" />Je peux naviguer en toute discrétion.
          Je peux me rendre invisible sur le site, tout en pouvant communiquer avec les membres.
        </div>
        <p>
          Les fonctionnalités Filtre de contact et mode invisible sont accessibles dans le menu
          <strong>Mon Compte / Confidentialité </strong>
        </p>
      </template>
    </PassChoice>
  </div>
</template>

<script>
import BasePage from "@/components/pages/BasePage";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import PassChoice from "../pass/PassChoice.vue";

export default {
  extends: BasePage,
  name: "Pass",
  components: { PassChoice },

  data() {
    return {
      serenityInfo: null,
      product: null,
      prorata: null
    };
  },

  methods: {
    init: async function() {
      this.serenityInfo = await idyuJsonRpc("getSerenityInfo");
      this.product = await idyuJsonRpc("getPassInformationSerenite");
      this.prorata = this.serenityInfo.prorata * this.product.price;
      if (this.prorata < 0.5) {
        this.prorata = 0.5;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.supplement {
  font-weight: bold;
}
</style>
